import { dataRotateClockwise } from 'dls-icons-data'
import { createIcon } from '../common'

const IconRotateClockwise = /*#__PURE__*/createIcon(dataRotateClockwise)
export default IconRotateClockwise
